import { ChangeContext, Options } from '@angular-slider/ngx-slider';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { Size } from '@models/common/size.model';
import { base64ToFile2 } from '@functions/files';

@Component({
  selector: 'app-cropper',
  templateUrl: './cropper.component.html',
  styleUrls: ['./cropper.component.scss'],
})
export class CropperComponent {
  @Input() file!: File;
  @Input() size: Size | null = null;
  @Input() getRawBase64: boolean | null = false;
  private cropped: ImageCroppedEvent;
  @Output() emitter: EventEmitter<File | any> = new EventEmitter();
  @Output() keep = new EventEmitter();

  rotation = 0;
  canvasRotation = 0;
  transform: ImageTransform = {
    translateUnit: 'px',
  };
  translateH = 0;
  translateV = 0;

  options: Options = {
    floor: 0,
    ceil: 360,
    showTicks: true,
    step: 1,
    tickStep: 45,
    translate: (value: number): string => {
      return value + '°';
    },
  };

  imageCropped(image: ImageCroppedEvent) {
    this.cropped = image;
  }

  success() {
    if (this.cropped) {
      if (this.getRawBase64) {
        this.emitter.emit(this.cropped);
      } else {
        base64ToFile2(
          `${this.cropped.base64}`,
          `${this.file.name}`,
          'image/jpg'
        ).then(file => {
          if (file) {
            this.emitter.emit(file);
          }
        });
      }
    }
  }

  userChangeEnd($event: ChangeContext) {
    setTimeout(() => {
      this.transform = {
        ...this.transform,
        rotate: $event.value,
      };
    });
  }

  private flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
      ...this.transform,
      flipH: flippedV,
      flipV: flippedH,
    };
    this.translateH = 0;
    this.translateV = 0;
  }
}
